<rt-box variant="default no-padding" layout-vertical padding-lr>
  <div class="body">
    <div class="row title">
      @if (item.url) {
        <a [href]="item.url"
          ><span class="title-text">{{ item.title }}</span>
          <ng-container *ngTemplateOutlet="badge" />
        </a>
      } @else {
        <span class="title-text">{{ item.title }}</span>
        <ng-container *ngTemplateOutlet="badge" />
      }

      <ng-template #badge>
        <rt-badge
          color="secondary"
          [rtClickToCopy]="item.guid"
          [rtTooltip]="'app.offer.copy_id' | translate"
          [text]="'#' + item.guid"
          (click)="$event.preventDefault()"
          margin-left-small
        />
      </ng-template>
    </div>
    <div class="row details">
      @if (item.department) {
        <span
          #departmentRef
          [rtTooltip]="item.department"
          [rtTooltipPosition]="'below'"
          [rtTooltipEnabled]="departmentLabelTooltipEnabled"
          [class.restricted]="item.locationIds?.length"
          class="department"
          text-weight-semi-bold
          >{{ item.department }}</span
        >
      }
      @if (item.locationIds?.length || item.location) {
        @if (item.department) {
          <rt-divider variant="dot" />
        }
        @if (item.locationIds?.length) {
          <rt-assigned-locations-info-container
            [locationIds]="item.locationIds!"
            [showIcon]="true"
          />
        } @else {
          <span>{{ item.location }}</span>
        }
      }
    </div>
  </div>
  <rt-divider variant="line" />
  <div class="row footer">
    <rt-heading variant="heading large-x">{{ item.qualifiedCount }}</rt-heading
    ><span margin-left-small-x margin-right-small>{{
      'app.offers.actions.x_qualified_candidates' | translate: { count: item.qualifiedCount }
    }}</span>
    @if (item.hiredCount) {
      <span
        [rtTooltip]="
          'app.offers.actions.x_hires_candidates' | translate: { count: item.hiredCount }
        "
        class="row"
        clickable
      >
        <rt-icon name="hired" margin-right-small-xx /><span margin-right-small-x>{{
          item.hiredCount
        }}</span>
      </span>
    }
    @if (item.disqualifiedCount) {
      <span class="separator"></span>
      <span
        [rtTooltip]="
          'app.offers.actions.x_disqualified_candidates'
            | translate: { count: item.disqualifiedCount }
        "
        class="row"
        clickable
      >
        <rt-icon name="block" /><span>{{ item.disqualifiedCount }}</span>
      </span>
    }

    <rt-button variant="plain" [disabled]="true">
      <rt-offer-status [status]="item.status" [offerStatus]="item.status" />
    </rt-button>
  </div>
</rt-box>
